import moduleSeekersStates from "asokoinsight-platforms/src/zidr/states/seekers-states";
import moduleInvesteeStates from "asokoinsight-platforms/src/zidr/states/investee-states";
import moduleInvestorStates from "asokoinsight-platforms/src/zidr/states/investor-states";

import localSeekersStates from "./seekers-states";
import localInvesteeStates from "./investee-states";
import localInvestorStates from "./investor-states";
import intermediaryStates from "./intermediary-states";
import matchStates from "./match-states";

// Prefer shared platform states from asokoinsight-platforms; fall back to local
const seekersStates = moduleSeekersStates || localSeekersStates;
const investeeStates = moduleInvesteeStates || localInvesteeStates;
const investorStates = moduleInvestorStates || localInvestorStates;

export {
  seekersStates,
  investeeStates,
  investorStates,
  intermediaryStates,
  matchStates,
};
